export interface CoreUserState {
  lastSelectedClientId?: string;
  lastSelectedProjectId?: string;
}
